import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface ManagerGroup {
  name: string;
  api_token: string;
}

export interface ManagerInfo {
  errors: unknown;
  listManagerGroup: ManagerGroup;
  isAuthenticated: boolean;
}

@Module
export default class ManagerGroupModule
  extends VuexModule
  implements ManagerInfo
{
  errors = {};
  listManagerGroup = {} as ManagerGroup;
  managerGroupDetail = {};
  listSearch = {};
  isAuthenticated = !!JwtService.getToken();

  get getListManagerGroup() {
    return this.listManagerGroup;
  }

  get getManagerGroupDetail() {
    return this.managerGroupDetail;
  }

  @Mutation
  [Mutations.MANAGER_GROUP_LIST_DATA](listManagerGroup) {
    this.listManagerGroup = listManagerGroup;
  }

  @Mutation
  [Mutations.MANAGER_GROUP_DETAIL_DATA](managerGroupDetail) {
    this.managerGroupDetail = managerGroupDetail;
  }

  @Action
  [Actions.MANAGER_GROUP_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/group", payload)
        .then((data) => {
          this.context.commit(Mutations.MANAGER_GROUP_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.MANAGER_GROUP_DETAIL](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/group/${payload.id}/detail`)
        .then((data) => {
          this.context.commit(Mutations.MANAGER_GROUP_DETAIL_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.MANAGER_GROUP_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`group/${payload.id}/delete`, payload)
        .then((res) => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.MANAGER_GROUP_UPSERT](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const idPath = payload.get("id") ? `/${payload.get("id")}` : "";
      return ApiService.post(`/group/upsert${idPath}`, payload)
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
